/* eslint-disable */
import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'


import Welcome  from "@/views/welcome";
import OnboadingView  from "@/views/welcome/onboading";
import PseudoView  from "@/views/welcome/pseudo";
import ChoiceView  from "@/views/welcome/choice";
import LayoutBasicView from "@/views/master/layouts/layoutBasic"
import HomeView from '@/views/master/home/home'
import MenuView from '@/views/master/menu/menuList'
import MenuDetailView from '@/views/master/menu/menuDetail'
import EditMenuView from '@/views/master/menu/editMenu'
import OrdersView from '@/views/master/orders/orders'
import OrderDetailsView from '@/views/master/orders/orderDetails'
import NotificationView from '@/views/notification/notification'
import EventView from '@/views/event/event'
import NpsEmptyView from '@/views/nps/empty'
import NpsQuestionView from '@/views/nps/nps'
import CartView from '@/views/master/menu/cart'
import CallServerView from '@/views/master/call/callServer'
import TableView from '@/views/master/table/setTable'
import MusiqueView from '@/views/master/musique/musiques'
import MusiqueDetailsView from '@/views/master/musique/details'

const routes = [
    {
        path : '/',
        component : OnboadingView,
        name : 'boading-page',
        meta: { redirectIfAuthenticated: true },
    },
    {
        path : '/pseudo',
        component : PseudoView,
        name : 'pseudo-page',
        meta: { redirectIfAuthenticated: true },
    },
    {
        path : '/choose',
        component : ChoiceView,
        name : 'choose-page'
    },
    {
        path : '/settings/table',
        component : TableView,
        name : 'table-page'
    },
    {
        path: '/master',
        component: LayoutBasicView, // Change the desired Layout here
        meta: { requiresAuth: true },
        children: [
            {
                path: '/welcome',
                component: HomeView,
                name: 'home-page',
            },
            {
                path: '/category/:id/menus',
                component: MenuView,
                name: 'menu-page',
            },
            {
                path: '/menu/:_id/details',
                component: MenuDetailView,
                name: 'menu-detail-page',
            },
            {
                path: '/menu/:id/edit',
                component: EditMenuView,
                name: 'edit-menu-page',
            },
            {
                path: '/cart',
                component: CartView,
                name: 'cart-page',
            },
            {
                path : '/orders',
                component : OrdersView,
                name : 'orders-page'
            },
            {
                path : '/orders/:id/details',
                component : OrderDetailsView,
                name : 'orders-details-page'
            },
            {
                path : '/call/server',
                component : CallServerView,
                name : 'call-server-page'
            },
        ]
    },
    {
        path: '/views',
        component: LayoutBasicView, // Change the desired Layout here
        meta: { requiresAuth: false },
        children: [
            {
                path: '/notification',
                component: NotificationView,
                name: 'notification-page',
            },
            {
                path: '/gospel/event',
                component: EventView,
                name: 'gospel-event-page',
            },
            {
                path: '/nps/empty',
                component: NpsEmptyView,
                name: 'nps-empty-page',
            },
            {
                path: '/nps/questions',
                component: NpsQuestionView,
                name: 'nps-questions-page',
                meta: { requiresOrder: true },
            },
            {
                path: '/musiques',
                component: MusiqueView,
                name: 'musiques-page',
            },
            {
                path: '/musiques/:id/lyrics',
                component: MusiqueDetailsView,
                name: 'musique-lyrics-page',
            },
        ]
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach(async (to, from, next) => {
    if (to.matched.some(m => m.meta.requiresAuth) && !store.getters['auth/isAuthenticated']) {
        return next({name: 'pseudo-page'})
    }

    if (to.matched.some(m => m.meta.requiresOrder)) {
        if(store.getters['order/getOrders'].length == 0){
            return next({name: 'nps-empty-page'})
        }
    }

    if (to.matched.some(m => m.meta.redirectIfAuthenticated) && store.getters['auth/isAuthenticated']) {
        return next({name: 'home-page'})
    }

    return next()
})


export default router
